var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendEducationEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.941V8.93541C16 8.75593 16 8.66619 15.9727 8.58696C15.9485 8.5169 15.9091 8.45309 15.8572 8.40014C15.7986 8.34027 15.7183 8.30013 15.5578 8.21987L11 5.94098M3 6.94098V13.7476C3 14.1195 3 14.3055 3.05802 14.4683C3.10931 14.6122 3.1929 14.7425 3.30238 14.8491C3.42622 14.9697 3.59527 15.0471 3.93335 15.2021L10.3334 18.1354C10.5786 18.2478 10.7012 18.304 10.8289 18.3262C10.9421 18.3459 11.0579 18.3459 11.1711 18.3262C11.2988 18.304 11.4214 18.2478 11.6666 18.1354L18.0666 15.2021C18.4047 15.0471 18.5738 14.9697 18.6976 14.8491C18.8071 14.7425 18.8907 14.6122 18.942 14.4683C19 14.3055 19 14.1195 19 13.7476V6.94098M1 5.94098L10.6422 1.11987C10.7734 1.05428 10.839 1.02148 10.9078 1.00857C10.9687 0.997142 11.0313 0.997142 11.0922 1.00857C11.161 1.02148 11.2266 1.05428 11.3578 1.11987L21 5.94098L11.3578 10.7621C11.2266 10.8277 11.161 10.8605 11.0922 10.8734C11.0313 10.8848 10.9687 10.8848 10.9078 10.8734C10.839 10.8605 10.7734 10.8277 10.6422 10.7621L1 5.94098Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendEducationEvents);
export default __webpack_public_path__ + "static/media/attend_education_events.bf306cec2f19a732d3a86774dee9dbc7.svg";
export { ForwardRef as ReactComponent };